import * as React from 'react'
import * as Redux from 'react-redux'

import { t } from '@owl-nest/localize'
import { useAuth } from '@owl-nest/redux-wrapper/hooks'
import { CATEGORY } from '@owl-nest/shadow'

import { glyphs, ActionButton } from '@ulule/owl-kit-components/next'

import * as modalAction from '../../../../actions/modal'
import { useReduxProjectFollowing } from '../hooks/useReduxProjectFollowing'
import { TRACKING_ACTION, TRACKING_SOURCE } from '../utils/trackerEnums'

type FollowProjectButtonProps = {
  source: TRACKING_SOURCE
  shouldReloadPage?: boolean
}

export function FollowProjectButton({
  source,
  shouldReloadPage,
}: FollowProjectButtonProps): React.ReactElement<FollowProjectButtonProps> {
  const auth = useAuth()
  const dispatch = Redux.useDispatch()
  const { toggleFollowing, userFollowsProject } = useReduxProjectFollowing({
    trackingExtraData: {
      eventCategory: CATEGORY.PROJECT_PAGE,
      eventAction: TRACKING_ACTION.FOLLOW_PROJECT,
      eventLabel: source,
    },
  })

  const followingStatusRef = React.useRef(userFollowsProject)

  const userIsAuthenticated = auth.type === 'loggedin'

  React.useEffect(() => {
    if (!followingStatusRef.current && userFollowsProject) {
      dispatch(modalAction.toggleModalFollow(true, shouldReloadPage))
    } else followingStatusRef.current = userFollowsProject
  }, [userFollowsProject])

  return (
    <ActionButton
      active={userFollowsProject}
      onClick={() => {
        if (!userIsAuthenticated) dispatch(modalAction.toggleModalFollow(true))
        else {
          toggleFollowing()
        }
      }}
      contents={{
        active: (
          <>
            <span>{t('Followed')}</span> <glyphs.fill.Heart size={17} />
          </>
        ),
        activeHover: <span>{t('Unfollow')}</span>,
        inactive: (
          <>
            <span>{t('Follow')}</span> <glyphs.stroke.Heart size={17} />
          </>
        ),
      }}
    />
  )
}
